import { ConfirmPopup, Icon } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';

interface IReferralLinkModalsProps {
  showPopup: {
    isOpen: boolean;
    title: string;
    description: string;
    isSuccess: boolean;
    showIcon: boolean;
  };
  onClosePopup: () => void;
}

export const ReferralLinkModals = ({ showPopup, onClosePopup }: IReferralLinkModalsProps) => {
  return (
    <>
      {showPopup.isOpen && (
        // @ts-expect-error - missing props
        <ConfirmPopup
          Icon={() =>
            showPopup.showIcon ? (
              <div style={{ marginBottom: 20 }}>
                {showPopup.isSuccess ? (
                  <AnimatedCheckCircle />
                ) : (
                  <Icon name="close-circle" size={80} />
                )}
              </div>
            ) : null
          }
          title={showPopup.title}
          description={showPopup.description}
          rightButtonAction={onClosePopup}
          rightButtonText={showPopup.isSuccess ? 'Got it!' : 'Close'}
          descriptionStyle={{ marginBottom: 40 }}
        />
      )}
    </>
  );
};
